require("../scss/style.scss");
import Swiper from "swiper";
import LazyLoad from "vanilla-lazyload";
import { Thumbs, Navigation } from "swiper/modules";

// import GLightbox from "glightbox";
require("./lib/fresco.min.js");
import OMCD from "./OMCD";

// import "./plugins.js";

import { vhCalc, docReady } from "./lib/helpers";
window.ll = new LazyLoad({
  elements_selector: "[data-src]",
  load_delay: 100,
  callback_loaded: function callback_loaded(el) {
    el.classList.remove("loading");
  },
  callback_error: function callback_error(e) {
    console.log(e);
  },
  callback_enter: function callback_enter(e) {
    // console.log("callback_enter");
  },
  callback_reveal: function callback_reveal(el) {
    if (el.complete && el.naturalWidth !== 0) {
      el.classList.remove("loading");
    }
  }
});
function DomScripts() {
  var swiper = new Swiper(".swiper--small", {
    modules: [Thumbs, Navigation],
    spaceBetween: 0,
    // slidesPerView: 5,
    slidesPerView: "auto",
    freeMode: true,
    lazy: {
      enable: true,
      loadPrevNext: true
    },
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  var swiper2 = new Swiper(".swiper--big", {
    modules: [Thumbs],
    allowTouchMove: false,
    spaceBetween: 2,
    lazy: {
      enable: true,
      loadPrevNext: true
    },
    thumbs: {
      autoScrollOffset: 2,
      swiper: swiper
    }
  });

  // var lightbox = GLightbox({});
}
document.documentElement.className = document.documentElement.className.replace("no-js", "js");
docReady(function () {
  DomScripts();
  var APP = {} || APP;
  APP.omcd = new OMCD($);
  window.ll.update();
});